import { createSelector } from 'reselect';
import { studentPreferencesSelector } from './studentPreferences';

export default createSelector(
    studentPreferencesSelector,
    (preferences) => preferences && preferences.movedToNextModule,
);
